document.addEventListener("DOMContentLoaded", function () {
    console.log("section-article-related-products.js loaded")

    const $articleRelatedProducts = $("section.article-related-products")
    const $articleRelatedProductsWrapper = $articleRelatedProducts.find(".wrapper")
    const $products = $articleRelatedProductsWrapper.find(".products")

    // console.log("$articleRelatedProducts", $articleRelatedProducts)
    // console.log("$articleRelatedProductsWrapper", $articleRelatedProductsWrapper)
    // console.log("$products", $products)

    $products.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: $articleRelatedProductsWrapper.find('.slick-prev'),
        nextArrow: $articleRelatedProductsWrapper.find('.slick-next'),
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: "unslick"
            }
        ]
    })
})
